import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" fill="currentColor">
      <circle cx="30" cy="45.6" r="2" />
      <path d="M32 12h-4a1 1 0 00-1 1l2 24a1 1 0 001 0 1 1 0 001 0l2-24a1 1 0 00-1-1z" />
    </svg>
  </span>
);

export default icon;
